<template>
    <iframe style="display: none;" ref="iframe" />
</template>

<script setup lang="ts">        
    import { computed, ComputedRef, onMounted, ref, watch } from "vue";
    import { commClient } from "fw4-library";
    
    let props = defineProps({
        fileId: {
            type: String,
            default: ""
        }
    });

    let emit = defineEmits(['formSubmitted']);

    const iframe: any = ref(null);

    let html: string = `
        <html>
            <head>
            </head>
            <body style="margin:0;padding:0;">
                <form name="exportform" id="reportform" method="post" action="/appinvoke/download">
                </form>
            </body>
        </html>`; 
        
    const fileIdComputed: ComputedRef<string> = computed(() => props.fileId);

    watch(fileIdComputed, () => {
        if(fileIdComputed.value != ""){
            iframe.value.contentWindow.document.write(html);            
            let form = iframe.value.contentWindow.document.getElementById('reportform');
            form.innerHTML = '';            

            let formField = document.createElement('input');
            formField.type = 'hidden';
            formField.name = "FileId";
            formField.value = props.fileId;
            form.appendChild(formField);

            formField = document.createElement('input');
            formField.type = 'hidden';
            formField.name = "MethodId";
            formField.value = commClient.getNewMethodId().toString();
            form.appendChild(formField);                
            form.submit();

            emit('formSubmitted');
        }
    });
</script>